import Permissions from '@/app/permissions/Permissions';
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';

const ENVELOPES_TABS = {
    ENVELOPES:
    {
        name: 'envelopes',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.LIST_REMOTE_DOWNLOADS.name] })
    },
    DOWNLOAD_CODES:
    {
        name: 'download_codes',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.LIST_REMOTE_DOWNLOADS.name] })
    }
};

ENVELOPES_TABS.DEFAULT = ENVELOPES_TABS.ENVELOPES;

export default ENVELOPES_TABS;